export { default } from './index.vue';